import { useCallback, useLayoutEffect, useState } from 'react';

export const useStickyNav = (el: Element | null) => {
    const [isSticky, setIsSticky] = useState(false);

    const toggleSticky = useCallback(
        ({ top }) => {
            if (top <= 0) {
                !isSticky && setIsSticky(true);
            } else {
                isSticky && setIsSticky(false);
            }
        },
        [isSticky],
    );

    useLayoutEffect(() => {
        const handleScroll = () => {
            toggleSticky(el?.getBoundingClientRect());
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [toggleSticky, el]);

    return {
        isSticky,
    };
};
